import React, { PureComponent } from "react";

const LINE1 = "3 Trends to Watch";
const LINE1_SUBTITLE = "in Today's Market";

/**
 * Title + subtitle only; area / neighborhood name appears in SentenceTrendsBodyOld.
 */
class SentenceTrendsHeaderOld extends PureComponent {
  //testing
  render() {
    return (
      <div className="sentence-trends-header-wrap-old">
        <div className="sentence-trends-db-header-old">
          <div className="sentence-trends-db-header-main-old">{LINE1}</div>
          <div className="sentence-trends-db-header-mid-old">{LINE1_SUBTITLE}</div>
        </div>
      </div>
    );
  }
}

export default SentenceTrendsHeaderOld;
